import React, { Component } from "react";
import { connect } from "react-redux";

import RadioInputPair from "components/source/shared/radio-input-pair";
import RtrButton from "components/design-system/rtr-button";
import PropTypes from "prop-types";
import MembershipPickWayfind from "components/source/membership/membership-pick-wayfind";
import MembershipShippingAddress from "components/source/membership/membership-shipping-address";
import FlagsAndExperimentsActions from "../../../actions/flags-and-experiments-actions";
import { withFlagsAndExperiments, flagsAndExperimentNames } from "../hoc/with-flags-and-experiments";
import { compose } from "redux";
import FitGuarantee from "components/source/shared/fit-guarantee/fit-guarantee";
import PromoExclusion from "components/source/products/promo-exclusion";
import MembershipHelpers from "helpers/membership-helpers";
import { shouldExcludePromo } from "helpers/product-drawer-helper";

export class AddToBagRadioContainer extends Component {
  static propTypes = {
    disabledCTACopy: PropTypes.string,
    className: PropTypes.string,
    fetchFlagTreatment: PropTypes.func.isRequired,
    handleWayfindCtaClick: PropTypes.func,
    membershipBag: PropTypes.object,
    membershipState: PropTypes.object,
    product: PropTypes.object.isRequired,
    radioButtons: PropTypes.arrayOf(
      PropTypes.shape({
        disabled: PropTypes.bool.isRequired,
        defaultChecked: PropTypes.bool.isRequired,
        price: PropTypes.element.isRequired,
        ctaCopy: PropTypes.string.isRequired,
        copy: PropTypes.element.isRequired,
        key: PropTypes.string.isRequired,
      })
    ),
    userData: PropTypes.object,
    workingFilters: PropTypes.object,
    staticProduct: PropTypes.object,
    flagsAndExperiments: PropTypes.object,
    drawerStaticProduct: PropTypes.object,
  };

  static hasRequestedFlag = false;

  state = {
    selectedRadioButton: true,
  };

  componentDidMount() {
    if (!AddToBagRadioContainer.hasRequestedFlag) {
      AddToBagRadioContainer.hasRequestedFlag = true;
      this.props.fetchFlagTreatment();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.membershipState !== this.props.membershipState ||
      prevProps.product !== this.props.product ||
      prevProps.userData !== this.props.userData ||
      prevProps.workingFilters !== this.props.workingFilters
    ) {
      if (!AddToBagRadioContainer.hasRequestedFlag) {
        AddToBagRadioContainer.hasRequestedFlag = true;
        this.props.fetchFlagTreatment();
      }
    }
  }

  onClick = () => {
    this.setState({
      selectedRadioButton: !this.state.selectedRadioButton,
    });
  };

  renderMembershipPickWayfind() {
    const { handleWayfindCtaClick, membershipState, product, userData } = this.props;

    return (
      <>
        <MembershipShippingAddress />
        <MembershipPickWayfind
          handleWayfindCtaClick={handleWayfindCtaClick}
          membershipState={membershipState}
          product={product}
          userData={userData}
        />
      </>
    );
  }

  optionIsSelected = option => !option.disabled && option.defaultChecked === this.state.selectedRadioButton;

  getActiveRadioButton() {
    const { radioButtons } = this.props;
    return radioButtons.find(this.optionIsSelected);
  }

  renderCopy() {
    const activeButton = this.getActiveRadioButton();
    if (!activeButton) {
      return this.renderMembershipPickWayfind();
    }
    const { copy } = activeButton;
    return copy;
  }

  renderActiveButtonContent() {
    const { disabledCTACopy, membershipBag: { isAddingItem } = {} } = this.props;
    const activeButtons = this.getActiveRadioButton();

    if (!activeButtons) {
      return (
        <RtrButton fullWidth disabled dataTestId="atom-full-width-btn">
          {disabledCTACopy}
        </RtrButton>
      );
    }

    const { ctaCopy, action, dataHeapId } = activeButtons;
    // TODO - add submitting button for KIF
    if (isAddingItem) {
      return (
        <RtrButton dataTestId="atom-full-width-btn" fullWidth loading disabled onClick={action} dataHeapId={dataHeapId}>
          Adding
        </RtrButton>
      );
    }

    return (
      <RtrButton fullWidth onClick={action} dataHeapId={dataHeapId} dataTestId="atom-full-width-btn">
        {ctaCopy}
      </RtrButton>
    );
  }

  renderRadioInput(radioInput) {
    return (
      <RadioInputPair
        id={radioInput.key}
        value={radioInput.key}
        disabled={radioInput.disabled}
        checked={this.optionIsSelected(radioInput)}
        label={radioInput.price}
        onChange={() => {
          this.onClick();
          if (typeof radioInput.onSelect === "function") {
            radioInput.onSelect();
          }
        }}
      />
    );
  }

  render() {
    const { radioButtons, userData, className } = this.props;

    const excludePromo = shouldExcludePromo({
      product: this.props?.staticProduct,
      fallbackProduct: this.props?.drawerStaticProduct,
      promoExclusionFlag:
        this.props.flagsAndExperiments?.[flagsAndExperimentNames.CATALOG_SERVICES_SHOW_PROMO_EXCLUSION],
    });

    // TODO: SACT-294 let's update this component to only return radio buttons and the CTA
    // and move the concierge/fit-guarantee as a sibling component
    return (
      <div className={`add-to-bag-radio-container ${className ? className : ""}`}>
        {radioButtons?.length > 0 && (
          <div>
            {radioButtons.map(button => {
              const buttonContentClassName = button.disabled ? "button-content__disabled" : "button-content";
              return (
                <div className={buttonContentClassName} key={button.key}>
                  {this.renderRadioInput(button)}
                </div>
              );
            })}
            <PromoExclusion shouldExclude={excludePromo} containerClass="pl-7 -mt-1" />
          </div>
        )}
        <FitGuarantee lens={MembershipHelpers.getUserDataLens(userData)} placement="pdp" className="my-2" />
        {this.renderActiveButtonContent()}
        {this.renderCopy()}
      </div>
    );
  }
}

const mapStateToProps = ({ membershipBag, userData, staticProduct, flagsAndExperiments, drawerStaticProduct }) => ({
  membershipBag,
  userData,
  staticProduct,
  flagsAndExperiments,
  drawerStaticProduct,
});
const mapDispatchToProps = dispatch => ({
  fetchFlagTreatment: () => {
    dispatch(FlagsAndExperimentsActions.fetchFlagOrExperiment(flagsAndExperimentNames.SWAT_CONCIERGE_UNAVAILABLE_PDPS));
  },
});

export default compose(
  withFlagsAndExperiments(flagsAndExperimentNames.SWAT_CONCIERGE_UNAVAILABLE_PDPS),
  connect(mapStateToProps, mapDispatchToProps)
)(AddToBagRadioContainer);
